import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import ParticipantDidSomething from '../common/ParticipantDidSomething';
import { getGoalValue } from 'utils/challenge';
import { getIndicatorConfig } from 'utils/common';

import { useText, useFormatNumber } from 'common/hooks';
import { ICON } from 'resources/constants';

type Props = {
  readonly datetime: number;
  readonly level: number;
  readonly profileKey: string;
};

const deps = {
  maxScore: state.challenge.maxScore,
  indicator: state.challenge.campaign.indicator,
};

export function ParticipantGoalSet({
  datetime,
  level,
  profileKey,
  maxScore,
  indicator,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const { unitPath } = getIndicatorConfig(indicator);
  const formatNumber = useFormatNumber();

  return (
    <ParticipantDidSomething
      profileKey={profileKey}
      icon={ICON.trackChanges}
      datetime={datetime}
    >
      {t(`challenge.participant_goal_set`, {
        goal: formatNumber(getGoalValue(maxScore, level) / 1_000_000),
        unit: t(unitPath),
      })}
    </ParticipantDidSomething>
  );
}

export default connect<Props, typeof deps>(deps, ParticipantGoalSet);
